module.exports = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTH_REQUIRED: 407,
  CLIENT_TIMEOUT: 408,
  CONFLICT: 409,
  RESOURCE_GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  ENTITY_TOO_LARGE: 413,
  URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  TEAPOT: 418,
  BAD_DATA: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  TOO_EARLY: 425,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,

  DEPOT_MAP_USER_SESSION_CHANGED: 430,
  DEPOT_MAP_CHANGED: 431,
  DEPOT_MAP_LOCKED: 432,
  DEPOT_MAP_LOCKED_IN_OTHER_BROWSER: 433,
  MATRIX_TEMPLATE_USER_SESSION_CHANGED: 435,
  MATRIX_TEMPLATE_CHANGED: 436,
  MATRIX_TEMPLATE_LOCKED: 437,
  MATRIX_TEMPLATE_LOCKED_IN_OTHER_BROWSER: 438,
  MATRIX_TEMPLATE_LOCKED_FOR_PLAN_COPY: 439,
  ROUTE_DAY_CHANGED: 441,
  ROUTE_DAY_LOCKED: 442,
  ROUTE_DAY_LOCKED_IN_OTHER_BROWSER: 443,
  ROUTE_DAY_LOCK_INVALID: 444,
  DRIVER_PROFILE_CHANGED: 445,
  DRIVER_PROFILE_LOCKED: 446,
  DRIVER_PROFILE_LOCKED_IN_OTHER_BROWSER: 447,
  DRIVER_PROFILE_LOCKED_FOR_PLAN_COPY: 448,
  DRIVER_PROFILE_LOCK_INVALID: 449,
  DRIVER_DAY_CHANGED: 450,
  DRIVER_DAY_LOCKED: 451,
  DRIVER_DAY_LOCKED_IN_OTHER_BROWSER: 452,
  DRIVER_DAY_LOCK_INVALID: 453,
  WEEKEND_ROUTE_OVERLAP: 454,

  INTERNAL: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};
